




















import { Component, Prop, Vue } from "vue-property-decorator";
import LogonComponent from "@/components/zorgID/LogonComponent.vue";
import { SecurityService } from "@/services/SecurityService";
import SessionOpenedViewModel from "@/models/security/zorgID/sessionOpenedViewModel";
import MandateListView from "@/components/mandate/ListView.vue";
import MainToolbar from "@/views/mandate/MainToolbar.vue";
import { ApplicationConfiguration } from "@/types/store";
import { Getter } from "vuex-class";

@Component({
  components: {
    "logon-zorgid-component": LogonComponent,
    "mandate-list-view": MandateListView,
    "main-toolbar": MainToolbar,
  },
})
export default class MandateView extends Vue {
  authenticatedWithUziPas: boolean = false;

  private created() {
    this.subscribeToEvents();
  }

  mounted() {
    this.validateAuthenticationUZIPas();
  }

  @Getter("applicationConfiguration")
  applicationConfiguration!: ApplicationConfiguration;

  private subscribeToEvents(): void {
    var me = this;
    SecurityService.getInstance().subscribeSessionOpenedReceived(x => {
      me.sessionOpened(x);
    });
  }

  private sessionOpened(sessionOpenedViewModel: SessionOpenedViewModel) {
    this.authenticatedWithUziPas = !sessionOpenedViewModel.IsCancelled;
  }

  private validateAuthenticationUZIPas(): void {
    this.authenticatedWithUziPas = SecurityService.getInstance().isLoggedOn();
  }
}
